<template>
  <div class="query">
    <el-card class="SJchaxun">
      <p>数据查询</p>
      <el-row :gutter="20" class="qiyemingcheng" style="margin-top:10px;">
        <el-col :span="3" class="biaoti"> 企业名称: </el-col>
        <el-col :span="20" class="xuanxiang">
          <el-input
            v-model="inputs"
            placeholder="请输入企业名称"
            clearable
          ></el-input>
        </el-col>
      </el-row>
      <el-row :gutter="20" class="hangye">
        <el-col :span="3" class="biaoti"> 行业: </el-col>
        <el-col :span="20" class="xuanxiang">
          <el-checkbox-button
            v-model="checkboxGroup1"
            v-for="city in cityOptions"
            @change="checkboxGroup1s(city.id)"
            :label="city.id"
            :key="city.id"
            >{{ city.value }}
          </el-checkbox-button>
        </el-col>
      </el-row>
      <el-row :gutter="20" class="qiyemingcheng">
        <el-col :span="3" class="biaoti"> 注册地居委会: </el-col>
        <el-col :span="8" class="xuanxiang">
          <el-input
            v-model="zhucedi"
            placeholder="请输入要搜索的注册地居委会名称"
            clearable
          ></el-input>
        </el-col>
        <el-col :span="3" class="biaoti"> 所在地居委会: </el-col>
        <el-col :span="8" class="xuanxiang">
          <el-input
            v-model="jingyingdi"
            placeholder="请输入要搜索的所在地居委会名称"
            clearable
          ></el-input>
        </el-col>
      </el-row>
      <!-- <el-row :gutter="20" class="qiyemingcheng">
        <el-col :span="3" class="biaoti"> 所在地居委会: </el-col>
        <el-col :span="20" class="xuanxiang">
          <el-input
            v-model="jingyingdi"
            placeholder="请输入要搜索的所在地居委会名称"
            clearable
          ></el-input>
        </el-col>
      </el-row> -->
      <el-row :gutter="20" class="qiyemingcheng">
        <el-col :span="3" class="biaoti"> 单位规模: </el-col>
        <el-col :span="8" class="xuanxiang">
          <el-select
            v-model="dwgm"
            placeholder="请选择单位规模"
          >
            <el-option
              v-for="item in dwgmx"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="3" class="biaoti"> 企业控股情况: </el-col>
        <el-col :span="8" class="xuanxiang">
          <el-select
            v-model="qykgqk"
            placeholder="请选择企业控股情况"
          >
            <el-option
              v-for="item in qykgqkx"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <!-- <el-row :gutter="20" class="qiyemingcheng">
        <el-col :span="3" class="biaoti"> 企业控股情况: </el-col>
        <el-col :span="20" class="xuanxiang">
          <el-select
            v-model="qykgqk"
            placeholder="请选择企业控股情况"
          >
            <el-option
              v-for="item in qykgqkx"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
      </el-row> -->
      <el-row :gutter="20" class="qiyemingcheng">
        <el-col :span="3" class="biaoti"> 登记注册类型: </el-col>
        <el-col :span="8" class="xuanxiang">
          <el-select
            v-model="djzclx"
            placeholder="请选择登记注册类型"
          >
            <el-option
              v-for="item in djzclxx"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="3" class="biaoti"> 运营状态: </el-col>
        <el-col :span="8" class="xuanxiang">
          <el-select
            v-model="yyzt"
            placeholder="请选择运营状态"
          >
            <el-option
              v-for="item in yyztx"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <!-- <el-row :gutter="20" class="qiyemingcheng">
        <el-col :span="3" class="biaoti"> 运营状态: </el-col>
        <el-col :span="20" class="xuanxiang">
          <el-select
            v-model="yyzt"
            placeholder="请选择运营状态"
          >
            <el-option
              v-for="item in yyztx"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
      </el-row> -->
      <el-row :gutter="20" class="qiyemingcheng">
        <el-col :span="3" class="biaoti"> 机构类型: </el-col>
        <el-col :span="8" class="xuanxiang">
          <el-select
            v-model="jglx"
            placeholder="请选择机构类型"
          >
            <el-option
              v-for="item in jglxx"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="3" class="biaoti"> 成立(开业)时间: </el-col>
        <el-col :span="8" class="xuanxiang">
          <el-date-picker
            v-model="kysjnian"
            type="year"
            placeholder="请选择年份"
            value-format="yyyy"
            format="yyyy"
          >
          </el-date-picker>
        </el-col>
      </el-row>
      <!-- <el-row :gutter="20" class="qiyemingcheng">
        <el-col :span="3" class="biaoti"> 成立(开业)时间: </el-col>
        <el-col :span="20" class="xuanxiang">
          <el-date-picker
            v-model="kysjnian"
            type="year"
            placeholder="请选择年份"
            value-format="yyyy"
            format="yyyy"
          >
          </el-date-picker>
        </el-col>
      </el-row> -->
      <el-row :gutter="20" class="qiyemingcheng">
        <el-col :span="3" class="biaoti"> 营业收入: </el-col>
        <el-col :span="8" class="xuanxiang">
          <el-select
            v-model="ids"
            placeholder="请选择营业收入"
            @change="handleDirChange($event)"
          >
            <el-option
              v-for="(item,value) in yysrx"
              :key="value"
              :label="item.label"
              :value="item.ids"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="3" class="biaoti"> 资产总计: </el-col>
        <el-col :span="8" class="xuanxiang">
          <el-select
            v-model="id"
            placeholder="请选择资产总计"
            @change="zczjChange($event)"
          >
            <el-option
              v-for="(item,value) in zczjx"
              :key="value"
              :label="item.label"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <!-- <el-row :gutter="20" class="qiyemingcheng">
        <el-col :span="3" class="biaoti"> 资产总计: </el-col>
        <el-col :span="20" class="xuanxiang">
          <el-select
            v-model="zczj"
            placeholder="请选择资产总计"
          >
            <el-option
              v-for="item in yysrx"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
      </el-row> -->

      <el-button class="chaxunanniu" @click="query">查询</el-button>
      <el-button class="chaxunanniu" @click="querys">查看所有企业</el-button>
    </el-card>
    <!-- 筛选结果 -->
    <el-card style="margin-top: 10px">
      <div class="hu">
        <div class="demo-input-suffix">
          <p>查询结果</p>
          <el-button
            type="primary"
            class="elbutton elbuttons"
            style="background: #071755; border: none"
            @click="tianjia"
            >添加企业信息</el-button
          >
          <el-button
            type="primary"
            class="elbutton"
            style="background: linear-gradient(90deg, #ffaf51, #ff671a);border: none;"
            icon="el-icon-download"
            @click="download"
            >下载企业名单
          </el-button>
        </div>
        <!-- 表格 -->
        <div class="eltable">
          <el-table
            ref="multipleTable"
            :data="tableData"
            height="650"
            border
            stripe
            size="mini"
            :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
            style="width: 100%"
          >
            <el-table-column width="165" prop="dwxxmc" fixed="left" label="单位详细名称">
            </el-table-column>
            <el-table-column
              width="165"
              prop="tyshxydm"
              label="统一社会信用代码"
            >
            </el-table-column>
            <el-table-column width="100" prop="zzjgdm" label="组织机构代码">
            </el-table-column>
            
            <el-table-column width="110" prop="zyywhd" label="主要业务活动">
            </el-table-column>
            <el-table-column width="100" prop="hydm" label="行业代码">
            </el-table-column>
            <el-table-column width="150" prop="jjhdmc" label="经济活动名称">
            </el-table-column>
            <el-table-column
              width="165"
              prop="szdsheng"
              label="单位所在地地址(省)"
            >
            </el-table-column>
            <el-table-column
              width="165"
              prop="szdshi"
              label="单位所在地地址(市)"
            >
            </el-table-column>
            <el-table-column
              width="165"
              prop="szdxian"
              label="单位所在地地址(县)"
            >
            </el-table-column>
            <el-table-column
              width="165"
              prop="szdjiedao"
              label="单位所在地地址(街道)"
            >
            </el-table-column>
            <el-table-column
              width="165"
              prop="szdjuweihui"
              label="单位所在地地址(居委会)"
            >
            </el-table-column>
            <el-table-column
              width="165"
              prop="szdjei"
              label="单位所在地地址(街)"
            >
            </el-table-column>
            <el-table-column
              width="165"
              prop="szdcode"
              label="单位所在地区划代码"
            >
            </el-table-column>
            <el-table-column
              width="165"
              prop="zcdsheng"
              label="单位注册地地址(省)"
            >
            </el-table-column>
            <el-table-column
              width="165"
              prop="zcdshi"
              label="单位注册地地址(市)"
            >
            </el-table-column>
            <el-table-column
              width="165"
              prop="zcdxian"
              label="单位注册地地址(县)"
            >
            </el-table-column>
            <el-table-column
              width="165"
              prop="zcdjiedao"
              label="单位注册地地址(街道)"
            >
            </el-table-column>
            <el-table-column
              width="165"
              prop="zcdjuweihui"
              label="单位注册地地址(居委会)"
            >
            </el-table-column>
            <el-table-column
              width="165"
              prop="zcdjie"
              label="单位注册地地址(街)"
            >
            </el-table-column>
            <el-table-column
              width="130"
              prop="zcdcode"
              label="单位注册地区划代码"
            >
            </el-table-column>
            <el-table-column width="100" prop="fddbr" label="法定代表人">
            </el-table-column>
            <el-table-column
              width="100"
              prop="kysjnian"
              label="开业(成立)时间年份"
            >
            </el-table-column>
            <el-table-column
              width="100"
              prop="kysjyue"
              label="开业(成立)时间月份"
            >
            </el-table-column>
            <el-table-column
              width="100"
              prop="wgwd"
              label="外国外地法人所属在京产业"
            >
            </el-table-column>
            <el-table-column width="100" prop="ggxqy" label="国高新企业">
            </el-table-column>
            <el-table-column width="100" prop="jxqQynb.yysr" label="营业收入">
            </el-table-column>
            <el-table-column width="100" prop="jxqQynb.zczj" label="资产总计">
            </el-table-column>
            <!-- fixed="right" -->
            <el-table-column
              align="center"
              label="操作"
              fixed="right"
              width="250"
            >
              <template slot-scope="code">
                <el-button
                  @click="see(code)"
                  type="text"
                  size="small"
                  style="color: #91cc75"
                  >查看</el-button
                >
                <el-button
                  @click="seenb(code)"
                  type="text"
                  size="small"
                  style="color: #91cc75"
                  >查看企业年报</el-button
                >
                <el-button
                  @click="handleClick(code)"
                  type="text"
                  size="small"
                  style="color: #91cc75"
                  >编辑</el-button
                >
                <el-button type="text" size="small" @click="dele(code)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 分页 -->
        <el-pagination
          page-size="100"
          :total="ye"
          :current-page.sync="yeshu"
          @current-change="abcd(yeshu)"
          @prev-click="bcd(yeshu)"
          @next-click="cd()"
        >
        </el-pagination>
      </div>
    </el-card>
    <!-- 编辑弹框 -->
    <div v-if="shows" class="bianji">
      <div class="biaoti">
        <el-button @click="quxiao" type="primary" icon="el-icon-close" class="guanbi"></el-button>
        修改企业基本信息
      </div>
      <div class="headers">
        <div class="bodys">
          <div>
            <span>统一社会信用代码:</span>
            <input
              type="text"
              :placeholder="e.tyshxydm"
              v-model="arr.tyshxydm"
            />
          </div>
          <div>
            <span>组织机构代码:</span>
            <input type="text" :placeholder="e.zzjgdm" v-model="arr.zzjgdm" />
          </div>
          <div>
            <span>单位详细名称:</span>
            <input type="text" :placeholder="e.dwxxmc" v-model="arr.dwxxmc" />
          </div>
          <div>
            <span>主要业务活动:</span>
            <input type="text" :placeholder="e.zyywhd" v-model="arr.zyywhd" />
          </div>
          <div>
            <span>行业代码:</span>
            <input type="text" :placeholder="e.hydm" v-model="arr.hydm" />
          </div>
          <div>
            <span>经济活动名称:</span>
            <input type="text" :placeholder="e.jjhdmc" v-model="arr.jjhdmc" />
          </div>
          <div>
            <span>单位所在地地址(省):</span>
            <input
              type="text"
              :placeholder="e.szdsheng"
              v-model="arr.szdsheng"
            />
          </div>
          <div>
            <span>单位所在地地址(市):</span>
            <input type="text" :placeholder="e.szdshi" v-model="arr.szdshi" />
          </div>
          <div>
            <span>单位所在地地址(县):</span>
            <input type="text" :placeholder="e.szdxian" v-model="arr.szdxian" />
          </div>
          <div>
            <span>单位所在地地址(街道):</span>
            <input
              type="text"
              :placeholder="e.szdjiedao"
              v-model="arr.szdjiedao"
            />
          </div>
          <div>
            <span>单位所在地地址(居委会):</span>
            <input
              type="text"
              :placeholder="e.szdjuweihui"
              v-model="arr.szdjuweihui"
            />
          </div>
          <div>
            <span>单位所在地地址(街):</span>
            <input type="text" :placeholder="e.szdjei" v-model="arr.szdjei" />
          </div>
          <div>
            <span>单位所在地区划代码:</span>
            <input type="text" :placeholder="e.szdcode" v-model="arr.szdcode" />
          </div>
          <div>
            <span>单位注册地地址(省):</span>
            <input
              type="text"
              :placeholder="e.zcdsheng"
              v-model="arr.zcdsheng"
            />
          </div>
          <div>
            <span>单位注册地地址(市):</span>
            <input type="text" :placeholder="e.zcdshi" v-model="arr.zcdshi" />
          </div>
          <div>
            <span>单位注册地地址(县):</span>
            <input type="text" :placeholder="e.zcdxian" v-model="arr.zcdxian" />
          </div>
          <div>
            <span>单位注册地地址(街道):</span>
            <input
              type="text"
              :placeholder="e.zcdjiedao"
              v-model="arr.zcdjiedao"
            />
          </div>
          <div>
            <span>单位注册地地址(居委会):</span>
            <input
              type="text"
              :placeholder="e.zcdjuweihui"
              v-model="arr.zcdjuweihui"
            />
          </div>
          <div>
            <span>单位注册地地址(街):</span>
            <input type="text" :placeholder="e.zcdjie" v-model="arr.zcdjie" />
          </div>
          <div>
            <span>单位注册地区划代码:</span>
            <input type="text" :placeholder="e.zcdcode" v-model="arr.zcdcode" />
          </div>
          <div>
            <span>法定代表人:</span>
            <input type="text" :placeholder="e.fddbr" v-model="arr.fddbr" />
          </div>
          <div>
            <span>开业(成立)时间年份:</span>
            <input
              type="text"
              :placeholder="e.kysjnian"
              v-model="arr.kysjnian"
            />
          </div>
          <div>
            <span>开业(成立)时间月份:</span>
            <input type="text" :placeholder="e.kysjyue" v-model="arr.kysjyue" />
          </div>
          <div>
            <span>外国外地法人所属在京产业:</span>
            <input type="text" :placeholder="e.wgwd" v-model="arr.wgwd" />
          </div>
          <div>
            <span>国高新企业:</span>
            <input type="text" :placeholder="e.ggxqy" v-model="arr.ggxqy" />
          </div>
        </div>
        <div class="buttom">
          <button @click="quxiao">取消修改</button>
          <button @click="queding" class="red">确认修改</button>
        </div>
      </div>
    </div>
    <!-- 查看 -->
    <div v-if="showss" class="chakan">
      <div class="biaoti">
        <el-button @click="quxiaos" type="primary" icon="el-icon-close" class="guanbi"></el-button>
        <!-- <button @click="quxiaos">返回</button> -->
          企业基本信息
      </div>
      <div class="headers">
        <div class="shang"></div>
        <div class="bodys">
          <div>
            <span>统一社会信用代码:</span>
            <span>{{ e.tyshxydm }}</span>
          </div>
          <div>
            <span>组织机构代码:</span>
            <span>{{ e.zzjgdm }}</span>
          </div>
          <div>
            <span>单位详细名称:</span>
            <span>{{ e.dwxxmc }}</span>
          </div>
          <div>
            <span>主要业务活动:</span>
            <span>{{ e.zyywhd }}</span>
          </div>
          <div>
            <span>行业代码:</span>
            <span>{{ e.hydm }}</span>
          </div>
          <div>
            <span>经济活动名称:</span>
            <span>{{ e.jjhdmc }}</span>
          </div>
          <div>
            <span>单位所在地地址(省):</span>
            <span>{{ e.szdsheng }}</span>
          </div>
          <div>
            <span>单位所在地地址(市):</span>
            <span>{{ e.szdshi }}</span>
          </div>
          <div>
            <span>单位所在地地址(县):</span>
            <span>{{ e.szdxian }}</span>
          </div>
          <div>
            <span>单位所在地地址(街道):</span>
            <span>{{ e.szdjiedao }}</span>
          </div>
          <div>
            <span>单位所在地地址(居委会):</span>
            <span>{{ e.szdjuweihui }}</span>
          </div>
          <div>
            <span>单位所在地地址(街):</span>
            <span>{{ e.szdjei }}</span>
          </div>
          <div>
            <span>单位所在地区划代码:</span>
            <span>{{ e.szdcode }}</span>
          </div>
          <div>
            <span>单位注册地地址(省):</span>
            <span>{{ e.zcdsheng }}</span>
          </div>
          <div>
            <span>单位注册地地址(市):</span>
            <span>{{ e.zcdshi }}</span>
          </div>
          <div>
            <span>单位注册地地址(县):</span>
            <span>{{ e.zcdxian }}</span>
          </div>
          <div>
            <span>单位注册地地址(街道):</span>
            <span>{{ e.zcdjiedao }}</span>
          </div>
          <div>
            <span>单位注册地地址(居委会):</span>
            <span>{{ e.zcdjuweihui }}</span>
          </div>
          <div>
            <span>单位注册地地址(街):</span>
            <span>{{ e.zcdjie }}</span>
          </div>
          <div>
            <span>单位注册地区划代码:</span>
            <span>{{ e.zcdcode }}</span>
          </div>
          <div>
            <span>法定代表人:</span>
            <span>{{ e.fddbr }}</span>
          </div>
          <div>
            <span>开业(成立)时间年份:</span>
            <span>{{ e.kysjnian }}</span>
          </div>
          <div>
            <span>开业(成立)时间月份:</span>
            <span>{{ e.kysjyue }}</span>
          </div>
          <div>
            <span>外国外地法人所属在京产业:</span>
            <span>{{ e.wgwd }}</span>
          </div>
          <div>
            <span>国高新企业:</span>
            <span>{{ e.ggxqy }}</span>
          </div>
        </div>
        
      </div>
    </div>
    <!-- 添加企业弹框 -->
    <div v-if="shou" class="tianjia">
      <div class="biaoti">
        <el-button @click="qxtj" type="primary" icon="el-icon-close" class="guanbi"></el-button>
        添加新企业
      </div>
      <div class="headerss">
        <div class="qwe">
          <div>
            <span>统一社会信用代码:</span>
            <input type="text" v-model="arrs.tyshxydm" />
          </div>
          <div>
            <span>组织机构代码:</span>
            <input type="text" v-model="arrs.zzjgdm" />
          </div>
          <div>
            <span>单位详细名称:</span>
            <input type="text" v-model="arrs.dwxxmc" />
          </div>
          <div>
            <span>主要业务活动:</span>
            <input type="text" v-model="arrs.zyywhd" />
          </div>
          <div>
            <span>行业代码:</span>
            <input type="text" v-model="arrs.hydm" />
          </div>
          <div>
            <span>经济活动名称:</span>
            <input type="text" v-model="arrs.jjhdmc" />
          </div>
          <div>
            <span>单位所在地地址(省):</span>
            <input type="text" v-model="arrs.szdsheng" />
          </div>
          <div>
            <span>单位所在地地址(市):</span>
            <input type="text" v-model="arrs.szdshi" />
          </div>
          <div>
            <span>单位所在地地址(县):</span>
            <input type="text" v-model="arrs.szdxian" />
          </div>
          <div>
            <span>单位所在地地址(街道):</span>
            <input type="text" v-model="arrs.szdjiedao" />
          </div>
          <div>
            <span>单位所在地地址(居委会):</span>
            <input type="text" v-model="arrs.szdjuweihui" />
          </div>
          <div>
            <span>单位所在地地址(街):</span>
            <input type="text" v-model="arrs.szdjei" />
          </div>
          <div>
            <span>单位所在地区划代码:</span>
            <input type="text" v-model="arrs.szdcode" />
          </div>
          <div>
            <span>单位注册地地址(省):</span>
            <input type="text" v-model="arrs.zcdsheng" />
          </div>
          <div>
            <span>单位注册地地址(市):</span>
            <input type="text" v-model="arrs.zcdshi" />
          </div>
          <div>
            <span>单位注册地地址(县):</span>
            <input type="text" v-model="arrs.zcdxian" />
          </div>
          <div>
            <span>单位注册地地址(街道):</span>
            <input type="text" v-model="arrs.zcdjiedao" />
          </div>
          <div>
            <span>单位注册地地址(居委会):</span>
            <input type="text" v-model="arrs.zcdjuweihui" />
          </div>
          <div>
            <span>单位注册地地址(街):</span>
            <input type="text" v-model="arrs.zcdjie" />
          </div>
          <div>
            <span>单位注册地区划代码:</span>
            <input type="text" v-model="arrs.zcdcode" />
          </div>
          <div>
            <span>法定代表人:</span>
            <input type="text" v-model="arrs.fddbr" />
          </div>
          <div>
            <span>开业(成立)时间年份:</span>
            <input type="text" v-model="arrs.kysjnian" />
          </div>
          <div>
            <span>开业(成立)时间月份:</span>
            <input type="text" v-model="arrs.kysjyue" />
          </div>
          <div>
            <span>外国外地法人所属在京产业:</span>
            <input type="text" v-model="arrs.wgwd" />
          </div>
          <div>
            <span>国高新企业:</span>
            <input type="text" v-model="arrs.ggxqy" />
          </div>
        </div>
        <div class="buttom">
          <button @click="qxtj">取消添加</button>
          <button class="red" @click="qrtj">确认添加</button>
        </div>
      </div>
    </div>
    <!-- 年报 -->
    <div v-if="nb" class="nb">
      <div class="biaoti">
        <el-button @click="fanhuis" type="primary" icon="el-icon-close" class="guanbi"></el-button>
        企业年报
      </div>
      <div class="head">
        <div v-if="jxqQynb == null || jxqQynb == undefined ? false : true">
          <!-- <button @click="fanhuis" class="button">返回</button> -->
          <div class="shang"></div>
          <div class="div">
            <span class="spana">单位详细名称:</span>
            <span class="spanb">{{ jxqQynb.dwxxmc }}</span>
          </div>
          <div class="div">
            <span class="spana">统一社会信用代码:</span>
            <span class="spanb">{{jxqQynb.tyshxydm}}</span>
          </div>
          <div class="div">
            <span class="spana">行业代码:</span>
            <span class="spanb">{{jxqQynb.hydm}}</span>
          </div>
          <div class="div">
            <span class="spana">主要业务活动1:</span>
            <span class="spanb">{{jxqQynb.zyywhd1}}</span>
          </div>
          <div class="div">
            <span class="spana">主要业务活动2:</span>
            <span class="spanb">{{jxqQynb.zyywhd2}}</span>
          </div>
          <div class="div">
            <span class="spana">主要业务活动3:</span>
            <span class="spanb">{{jxqQynb.zyywhd3}}</span>
          </div>
          <div class="div">
            <span class="spana">营业收入:</span>
            <span class="spanb">{{jxqQynb.yysr}}</span>
          </div>
          <div class="div">
            <span class="spana">资产总计:</span>
            <span class="spanb">{{jxqQynb.zczj}}</span>
          </div>
          <div class="div">
            <span class="spana">税金及附加:</span>
            <span class="spanb">{{jxqQynb.sjjfj}}</span>
          </div>
          
        </div>
        <div v-else class="ele">
          <!-- <button @click="fanhuis">返回</button> -->
          <div class="zanwu">
            这个企业暂时没有年报
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pagination from "../../components/common/pagination.vue";
import {
  qy,
  hy,
  qyput,
  qydele,
  qypost,
  qyspost,
  qyget,
  cxnb,
  nb,
} from "@/network";
export default {
  components: {
    pagination,
  },
  data() {
    return {
      xianshi: "1",
      showss: false,
      arrs: {},
      shou: false,
      arr: {},
      e: {},
      shows: false,
      ids: "",
      ye: "0",
      yeshu: "1",
      totals: 0,
      tableData: [],
      options: [],
      getInfo: [],
      total: null,
      cityOptions: [],
      checkboxGroup1: [],
      value: "",
      value1: "",
      value2: "",
      inputs: "",
      zhucedi:"",
      jingyingdi:"",
      dwgmx: [
        {
          value: "",
          label: "不限",
        },
        {
          value: "1",
          label: "大型",
        },
        {
          value: "2",
          label: "中型",
        },
        {
          value: "3",
          label: "小型",
        },
        {
          value: "4",
          label: "微型",
        },
      ],
      dwgm:"",
      qykgqkx: [
        {
          value: "",
          label: "不限",
        },
        {
          value: "1",
          label: "国有控股",
        },
        {
          value: "2",
          label: "集体控股",
        },
        {
          value: "3",
          label: "私人控股",
        },
        {
          value: "4",
          label: "港澳台商投资",
        },
        {
          value: "5",
          label: "外商投资",
        },
        {
          value: "6",
          label: "其他",
        },
      ],
      qykgqk:"",
      djzclxx: [
        {
          value: "",
          label: "不限",
        },
        {
          value: "110",
          label: "国有",
        },
        {
          value: "120",
          label: "集体",
        },
        {
          value: "130",
          label: "股份合作",
        },
        {
          value: "141",
          label: "国有联营",
        },
        {
          value: "142",
          label: "集体联营",
        },
        {
          value: "143",
          label: "国有与集体联营",
        },
        {
          value: "149",
          label: "其他联营",
        },
        {
          value: "151",
          label: "国有独资公司",
        },
        {
          value: "159",
          label: "其他有限公司",
        },
        {
          value: "160",
          label: "股份有限公司",
        },
        {
          value: "171",
          label: "私营独资",
        },
        {
          value: "172",
          label: "私营合伙",
        },
        {
          value: "173",
          label: "私营有限责任公司",
        },
        {
          value: "174",
          label: "私营股份有限公司",
        },
        {
          value: "190",
          label: "其他",
        },
        {
          value: "210",
          label: "与港澳台商合资经营",
        },
        {
          value: "220",
          label: "与港澳台商合作经营",
        },
        {
          value: "230",
          label: "港澳台商独资",
        },
        {
          value: "240",
          label: "港澳台商投资股份有限公司",
        },
        {
          value: "290",
          label: "其他港澳台商投资",
        },
        {
          value: "310",
          label: "中外合资经营",
        },
        {
          value: "320",
          label: "中外合作经营",
        },
        {
          value: "330",
          label: "外资企业",
        },
        {
          value: "340",
          label: "外商投资股份有限公司",
        },
        {
          value: "390",
          label: "其他外商投资",
        },
      ],
      djzclx:"",
      yyztx: [
        {
          value: "",
          label: "不限",
        },
        {
          value: "1",
          label: "正常营业",
        },
        {
          value: "2",
          label: "停业（歇业）",
        },
        {
          value: "3",
          label: "筹建",
        },
        {
          value: "4",
          label: "当年关闭",
        },
        {
          value: "5",
          label: "当年破产",
        },
        {
          value: "6",
          label: "当年注销",
        },
        {
          value: "7",
          label: "当年吊销",
        },
        {
          value: "9",
          label: "其他",
        },
      ],
      yyzt:"",
      jglxx: [
        {
          value: "",
          label: "不限",
        },
        {
          value: "10",
          label: "企业",
        },
        {
          value: "20",
          label: "事业单位",
        },
        {
          value: "30",
          label: "机关",
        },
        {
          value: "40",
          label: "社会团体",
        },
        {
          value: "51",
          label: "民办非企业单位",
        },
        {
          value: "52",
          label: "基金会",
        },
        {
          value: "53",
          label: "居委会",
        },
        {
          value: "54",
          label: "村委会",
        },
        {
          value: "55",
          label: "农民专业合作社",
        },
        {
          value: "56",
          label: "农村集体经济组织",
        },
        {
          value: "90",
          label: "其他组织机构",
        },
      ],
      jglx:"",
      kysjnian:"",
      yysrx: [
        {
          value: "",
          ids:"001",
          beginyysr:"",
          endyysr:"",
          label: "不限",
        },
        {
          value: "1",
          ids:"002",
          beginyysr:"0",
          endyysr:"100000",
          label: "≥0元，＜10万",
        },
        {
          value: "2",
          ids:"003",
          beginyysr:"100000",
          endyysr:"500000",
          label: "≥10万，＜50万",
        },
        {
          value: "3",
          ids:"004",
          beginyysr:"500000",
          endyysr:"1000000",
          label: "≥50万，＜100万",
        },
        {
          value: "4",
          ids:"005",
          beginyysr:"1000000",
          endyysr:"5000000",
          label: "≥100万，＜500万",
        },
        {
          value: "5",
          ids:"006",
          beginyysr:"5000000",
          endyysr:"10000000",
          label: "≥500万，＜1000万",
        },
        {
          value: "6",
          ids:"007",
          beginyysr:"10000000",
          endyysr:"50000000",
          label: "≥1000万，＜5000万",
        },
        {
          value: "7",
          ids:"008",
          beginyysr:"50000000",
          endyysr:"100000000",
          label: "≥5000万，＜1亿",
        },
        {
          value: "8",
          ids:"009",
          beginyysr:"100000000",
          endyysr:"500000000",
          label: "≥1亿，＜5亿",
        },
        {
          value: "9",
          ids:"010",
          beginyysr:"500000000",
          endyysr:"50000000000",
          label: "≥5亿",
        },
      ],
      zczjx: [
        {
          id:"101",
          beginzczj:"",
          endzczj:"",
          label: "不限",
        },
        {
          value: "1",
          id:"102",
          beginzczj:"0",
          endzczj:"100000",
          label: "≥0元，＜10万",
        },
        {
          value: "2",
          id:"103",
          beginzczj:"100000",
          endzczj:"500000",
          label: "≥10万，＜50万",
        },
        {
          value: "3",
          id:"104",
          beginzczj:"500000",
          endzczj:"1000000",
          label: "≥50万，＜100万",
        },
        {
          value: "4",
          id:"105",
          beginzczj:"1000000",
          endzczj:"5000000",
          label: "≥100万，＜500万",
        },
        {
          value: "5",
          id:"106",
          beginzczj:"5000000",
          endzczj:"10000000",
          label: "≥500万，＜1000万",
        },
        {
          value: "6",
          id:"107",
          beginzczj:"10000000",
          endzczj:"50000000",
          label: "≥1000万，＜5000万",
        },
        {
          value: "7",
          id:"108",
          beginzczj:"50000000",
          endzczj:"100000000",
          label: "≥5000万，＜1亿",
        },
        {
          value: "8",
          id:"109",
          beginzczj:"100000000",
          endzczj:"500000000",
          label: "≥1亿，＜5亿",
        },
        {
          value: "9",
          id:"110",
          beginzczj:"500000000",
          endzczj:"50000000000",
          label: "≥5亿",
        },
      ],
      id:"",
      ids:"",
      yysr:"",
      zczj:"",
      beginzczj:"",
      endzczj:"",
      beginyysr:"",
      endyysr:"",

      input: "",
      input1: "",
      input2: "",
      input3: "",
      valuess: "",
      jxqQynb: {},
      qb: {},
      nb: false,
    };
  },
  mounted() {
    this.getInfoList();
    this.getinfoListss();
    // this.seenbs();
  },
  methods: {
    handleDirChange(ids) {
      console.log(ids,540)
      let dir = this.yysrx.find((item) => item.ids === ids);
      console.log(dir,540)
      this.beginyysr = dir.beginyysr;
      this.endyysr = dir.endyysr;
      console.log(this.beginyysr,this.endyysr,540)
    },
    zczjChange(id) {
      console.log(id,541)
      let dir = this.zczjx.find((item) => item.id === id);
      console.log(dir,541)
      this.beginzczj = dir.beginzczj;
      this.endzczj = dir.endzczj;
      console.log(this.beginzczj,this.endzczj,541)
    },
    //企业年报
    async seenb(e) {
      let id = e.row.id;
      const { code, rows, data, total } = await qyget(id);
      this.jxqQynb = data.jxqQynb;
      this.qb = data;
      console.log(this.jxqQynb);
      this.nb = true;
    },
    fanhuis() {
      this.nb = false;
    },
    // async seenbs(){
    //   const { code, rows, data, total } = await nb();
    //   console.log(code, rows, data, total)
    // },
    checkboxGroup1s(e) {
      this.valuess = e;
    },
    //行业信息  Qiyebasicsssss
    async getinfoListss() {
      const { code, data, msg } = await hy({ pid: 0 });
      // console.log(data,code)
      this.cityOptions = data;
    },

    //筛选信息
    async query() {
      this.xianshi = 0;
      let dwxxmc = this.inputs;
      let hydm = this.valuess;
      let zcdjuweihui = this.zhucedi;
      let szdjuweihui = this.jingyingdi;
      let dwgm = this.dwgm;
      let qykgqk = this.qykgqk;
      let djzclx = this.djzclx;
      let yyzt = this.yyzt;
      let jglx = this.jglx;
      let kysjnian = this.kysjnian;
      // let yysr = this.yysr;
      // let zczj = this.zczj;
      let beginyysr = this.beginyysr;
      let endyysr = this.endyysr;
      let beginzczj = this.beginzczj;
      let endzczj = this.endzczj;
      const { code, rows, total } = await qy({
        dwxxmc,
        hydm,
        zcdjuweihui,
        szdjuweihui,
        dwgm,
        qykgqk,
        djzclx,
        yyzt,
        jglx,
        kysjnian,
        'jxqQynb.beginyysr':beginyysr,
        'jxqQynb.endyysr':endyysr,
        'jxqQynb.beginzczj':beginzczj,
        'jxqQynb.endzczj':endzczj,
        pageNum: this.yeshu,
        pageSize: 100,
      });
      if (code === 200) {
        this.tableData = rows;
        this.ye = total;
        this.total = total;
        this.checkboxGroup1 = [];
      }
    },
    querys() {
      this.xianshi = 1;
      this.getInfoList();
    },

    async getInfoList() {
      const { code, rows, total } = await qy({
        pageNum: this.yeshu,
        pageSize: 100,
        'jxqQynb.beginyysr':'',
        'jxqQynb.endyysr':'',
        'jxqQynb.beginzczj':'',
        'jxqQynb.endzczj':'',
      });
      // console.log(rows, 123);
      if (code === 200) {
        this.tableData = rows;
        // console.log(this.tableData, 987);
        this.ye = total;
        this.total = total;
      }
    },
    abcd(e) {
      //获取当前点击的页数
      if (this.xianshi == 0) {
        this.query();
      } else {
        this.getInfoList();
      }
      this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
    },
    bcd(e) {
      //点上一页
      this.yeshu = this.yeshu - 1;
      if (this.xianshi == 0) {
        this.query();
      } else {
        this.getInfoList();
      }
    },
    cd() {
      //点下一页
      this.yeshu = this.yeshu + 1;
      if (this.xianshi == 0) {
        this.query();
      } else {
        this.getInfoList();
      }
    },
    //添加接口  listsspost
    async post() {
      const { code, rows, total } = await qypost(this.arrs);
      this.getInfoList();
    },
    //点击添加
    tianjia() {
      this.shou = !this.shou;
      // console.log(123456789);
    },
    //取消添加
    qxtj() {
      this.shou = false;
    },
    //确定添加
    qrtj() {
      this.$confirm("此操作将永久添加数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "添加成功!",
          });
          this.shou = false;
          this.post();
          this.arrs = {};
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消添加",
          });
        });
    },

    //查看企业信息
    async see(e) {
      let id = e.row.id;
      const { code, rows, data, total } = await qyget(id);
      console.log(data);
      this.e = data;
      this.showss = true;
    },
    //返回
    quxiaos() {
      this.showss = false;
    },
    //取消修改
    quxiao() {
      this.shows = false;
    },
    // 修改接口
    async put() {
      let arr = {
        id: this.e.id,
        ...this.arr,
      };
      const { code, rows, total } = await qyput(arr);
      this.shows = false;
      this.getInfoList();
    },
    //确定修改
    queding() {
      this.$confirm("此操作将永久修改数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "修改成功!",
          });
          this.put();
          this.arr = {};
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消修改",
          });
        });
    },
    // 删除接口
    async getInfoListdele() {
      const { code, rows, total } = await qydele(this.ids);
      this.getInfoList();
    },
    // 删除
    dele(e) {
      this.ids = e.row.id;
      // 删除
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
          this.getInfoListdele();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleClick(e) {
      this.e = e.row;
      this.shows = true;
    },
    ///导出excel表格
    async download() {
      let excel = {
        siId: this.siId,
        startTime: this.times ? this.times[0] : "",
        endTime: this.times ? this.times[1] : "",
      };
      for (let i in excel) {
        if (!excel[i]) {
          delete excel[i];
        }
      }
      // jzmdposts(excel).then((res) => {
      //   console.log(res)
      const content = await qyspost();
      // console.log(content);
      const blob = new Blob([content]);
      const fileName = "企业名单.xlsx";
      if ("download" in document.createElement("a")) {
        // 非IE下载
        const elink = document.createElement("a");
        elink.download = fileName;
        elink.style.display = "none";
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href); // 释放URL 对象
        document.body.removeChild(elink);
      } else {
        // IE10+下载
        navigator.msSaveBlob(blob, fileName);
      }
      // });
    },
  },
};
</script>

<style scoped lang="less">
.nb {
  z-index: 99;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  font-size: 20px;
  background-color: rgba(0, 0, 0, 0.8);
  overflow: hidden;
  .biaoti{
    width: 90%;
    margin-left: 5%;
    margin-top: 3%;
    line-height: 50px;
    text-align: center;
    font-size: 20px;
    font-family: Source Han Sans CN;
    background-color: #edeff3;
    button{
      float: right;
      padding-right: 10px;
      color: #000;
      font-size: 26px;
      line-height: 46px;
      border-radius: 5px;
      width: 50px;
      border: 1px solid #edeff3;
      background-color: #edeff3;
    }
    .el-button{
      line-height: 46px;
      padding: 0;
    }
  }
  .head {
    width: 90%;
    height: 80%;
    margin: 0 5%;
    background-color: #fff;
    overflow-y: auto;
    overflow-x: hidden;
    .shang{
      height: 40px;
      border-bottom: 1px solid #edeff3;
      margin: 0 4vw;
    }

    .div {
      line-height: 50px;
      border: 1px solid #edeff3;
      border-top: 0px solid #edeff3;
      margin: 0 4vw;
      .spana {
        display: inline-block;
        width: 16vw;
        padding-left: 10px;
        border-right: 1px solid #edeff3;
      }
      .spanb {
        display: inline-block;
        padding-left: 10px;
      }
    }
    .button {
        width: 150px;
        height: 50px;
        border: 0;
        color: rgb(8, 84, 248);
        font-size: 18px;
        // margin-left: 80%;
        // background-color: rgb(0, 174, 255);
      }
    .ele {
      font-size: 30px;
      text-align: center;
      line-height: 80vh;
      color: rgb(0, 110, 255);
      .zanwu{
        width: 90%;
        font-family: Source Han Sans CN;
        // border: 1px solid #edeff3;
        margin: 0 4vw;
        // margin-top:20px;
        line-height: 80vh;
        text-align: center;
        font-size: 30px;
      }
      button {
        float: left;
        width: 150px;
        height: 50px;
        border: 0;
        color: rgb(8, 84, 248);
        font-size: 18px;
      }
    }
  }
}
.tianjia {
  z-index: 99;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  .biaoti{
    width: 90%;
    margin-left: 5%;
    margin-top: 3%;
    line-height: 50px;
    text-align: center;
    font-size: 20px;
    font-family: Source Han Sans CN;
    background-color: #edeff3;
    button{
      float: right;
      padding-right: 10px;
      color: #000;
      font-size: 26px;
      line-height: 46px;
      border-radius: 5px;
      width: 50px;
      border: 1px solid #edeff3;
      background-color: #edeff3;
    }
    .el-button{
      line-height: 46px;
      padding: 0;
    }
  }
  .headerss {
    width: 90%;
    height: 80%;
    margin: 0 5%;
    background-color: #fff;
    overflow-y: auto;
    overflow-x: hidden;
    .qwe {
      // width: 100%;
      // height: 90%;
      padding: 20px;
      padding-left: 3%;
      font-size: 20px;
      padding-top: 10px;
      input {
        border: 1px solid rgb(0, 153, 255);
        border-radius: 3px;
        padding: 5px;
      }
      input:focus {
        outline: none;
        border: 1px solid rgb(0, 153, 255);
      }
      div {
        display: inline-block;
        width: 50%;
        line-height: 60px;
        span {
          display: inline-block;
          width: 46%;
        }
      }
    }
    .buttom {
      margin-left: 20%;
      line-height: 20px;
      // padding: 2% 0;
      // padding-top: 15%;
      margin-bottom: 30px;
      button {
        width: 150px;
        height: 50px;
        border: 0;
        color: #fff;
        font-size: 20px;
        border-radius: 5px;
        background-color: rgb(0, 132, 255);
      }
      .red {
        margin-left: 40%;
        background-color: red;
      }
    }
  }
}
.chakan {
  z-index: 99;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  .biaoti{
    width: 90%;
    margin-left: 5%;
    margin-top: 3%;
    line-height: 50px;
    text-align: center;
    font-size: 20px;
    font-family: Source Han Sans CN;
    background-color: #edeff3;
    button{
      float: right;
      padding-right: 10px;
      color: #000;
      font-size: 26px;
      line-height: 46px;
      border-radius: 5px;
      width: 50px;
      border: 1px solid #edeff3;
      background-color: #edeff3;
    }
    .el-button{
      line-height: 46px;
      padding: 0;
    }
  }
  .headers {
    width: 90%;
    height: 80%;
    margin: 0 5%;
    background-color: #fff;
    overflow-y: auto;
    overflow-x: hidden;
    .shang{
      height: 40px;
      border-bottom: 1px solid #edeff3;
      margin: 0 5%;
    }
    .bodys {
      width: 100%;
      padding: 0 20px 50px;
      padding-left: 5%;
      font-size: 18px;
      div {
        width: 90%;
        line-height: 50px;
        border: 1px solid #edeff3;
        border-top: 0px solid #edeff3;
        span:nth-child(1) {
          display: inline-block;
          line-height: 50px;
          padding-left: 10px;
          border-right: 1px solid #edeff3;
          width: 30%;
        }
        span:nth-child(2) {
          display: inline-block;
          line-height: 50px;
          padding-left: 10px;
          width: 68%;
        }
      }
    }
  }
}
.bianji {
  z-index: 99;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  .biaoti{
    width: 90%;
    margin-left: 5%;
    margin-top: 3%;
    line-height: 50px;
    text-align: center;
    font-size: 20px;
    font-family: Source Han Sans CN;
    background-color: #edeff3;
    button{
      float: right;
      padding-right: 10px;
      color: #000;
      font-size: 26px;
      line-height: 46px;
      border-radius: 5px;
      width: 50px;
      border: 1px solid #edeff3;
      background-color: #edeff3;
    }
    .el-button{
      line-height: 46px;
      padding: 0;
    }
  }
  .headers {
    width: 90%;
    height: 80%;
    margin-left: 5%;
    background-color: #fff;
    overflow-y: auto;
    overflow-x: hidden;
    .bodys {
      padding-left: 5%;
      font-size: 20px;
      padding-top: 30px;
      input {
        border: 1px solid rgb(0, 153, 255);
        border-radius: 3px;
        padding: 6px;
      }
      input:focus {
        outline: none;
        border: 1px solid rgb(0, 153, 255);
      }
      div {
        display: inline-block;
        width: 45%;
        line-height: 50px;
        span {
          display: inline-block;
          width: 48%;
        }
      }
    }
  }
  .buttom {
    margin-left: 15vw;
    line-height: 100px;
    button {
      width: 150px;
      height: 50px;
      border: 0;
      color: #fff;
      font-size: 20px;
      border-radius: 5px;
      background-color: rgb(0, 132, 255);
    }
    .red {
      margin-left: 50%;
      background-color: red;
    }
  }
}
.eltable {
  overflow-y: auto;
}
.elbuttons {
  position: absolute;
  right: 15vw;
}
.hu {
  .demo-input-suffix {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    p {
      font-size: 16px;
      line-height: 36px;
    }
    .elinput {
      margin-right: 10px;
      margin-bottom: 10px;
    }
  }
}
.query {
  margin-left: 70px;
  font-size: 14px !important;
  color: #333333;
  .qiye {
    span {
      float: left;
      line-height: 50px;
    }
    .qujian {
      float: left;
      .el-input {
        height: 38px;
        width: 300px;
        border-radius: 4px;
        margin-top: 7px;
        font-size: 14px;
      }
    }
    .qiyechaxun {
      position: relative;
      // top: -16px;
      // left: 40vw;
    }
  }
  .SJchaxun {
    p {
      font-size: 16px;
      line-height: 16px;
      text-align: left;
      padding-bottom: 20px;
      font-weight: 600;
      border-bottom: 1px solid #edeff3;
    }
    .qiyemingcheng {
      // margin-top: 10px;
      .biaoti {
        float: left;
        line-height: 44px;
        text-align: right;
      }
      .xuanxiang {
        border: 0;
        .el-input {
          // height: 20px;
          width: 300px;
          border-radius: 4px;
          // margin-top: 7px;
          font-size: 14px;
        }
        .el-select{
          // height: 20px;
          width: 300px;
          border-radius: 4px;
          // margin-top: 7px;
          font-size: 14px;
        }
        .qiyechaxun {
          background-color: #072b55;
          color: #fff;
          width: 130px;
          height: 40px;
          border-radius: 4px;
          margin: 0 0 0 20px;
        }
      }
    }
    .hangye {
      // margin-top: 10px;
      .biaoti {
        float: left;
        line-height: 44px;
        text-align: right;
      }
      .xuanxiang {
        border: 0;
        .el-checkbox-button {
          // height: 38px;
          // overflow-wrap: break-word;
          // line-height: 38px;
          margin: 2px 5px 3px 0px;
          // padding: 0 16px;
          border-radius: 4px;
          border: 1px solid #dcdfe6;
        }
      }
    }
    .zichan {
      .biaoti {
        float: left;
        line-height: 50px;
      }
      .qujian {
        float: left;
        .el-input {
          height: 38px;
          width: 180px;
          border-radius: 4px;
          margin-top: 7px;
          font-size: 14px;
        }
      }
      span {
        float: left;
        line-height: 38px;
        border-radius: 4px;
        margin: 7px 10px 0;
      }
      .xuanxiang {
        float: left;
        line-height: 38px;
        border-radius: 4px;
        margin-top: 7px;
        padding-left: 20px;
      }
    }
    .yingye {
      .biaoti {
        float: left;
        line-height: 50px;
        // margin-left: 20px;
        // height: 50px;
        // width: 180px;
      }
      .qujian {
        float: left;
        .el-input {
          height: 38px;
          width: 180px;
          border-radius: 4px;
          margin-top: 7px;
          font-size: 14px;
        }
      }
      span {
        float: left;
        line-height: 38px;
        border-radius: 4px;
        margin: 7px 10px 0;
      }
      .xuanxiang {
        float: left;
        line-height: 38px;
        border-radius: 4px;
        margin-top: 7px;
        padding-left: 20px;
      }
    }
    .shuishou {
      .biaoti {
        // float: left;
        line-height: 50px;
        // margin-left: 20px;
        // height: 50px;
        // width: 180px;
      }
      .xuanxiang {
        line-height: 50px;
        height: 50px;
      }
    }
    .chaxunanniu {
      background-color: #071755;
      color: #fff;
      width: 130px;
      height: 46px;
      margin-top: 20px;
      // margin-left: 16px;
      border-radius: 4px;
    }
  }
}
.jieguo {
  margin-top: 16px;
}
.hu {
  p {
    font-size: 16px;
    line-height: 40px;
  }
  .demo-input-suffix {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    .elinput {
      margin-right: 10px;
      margin-bottom: 10px;
    }
    .el-button {
      height: 40px;
    }
  }
}
</style>
